import Swal from "sweetalert2";
<script>
import vue2Dropzone from 'vue2-dropzone'
import Multiselect from 'vue-multiselect'

import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config";
import Vue from "vue";
/**
 * Add-product component
 */
export default {
   page: {
    title: "Add DOMAIN PEMBELAJARAN",
    meta: [{ name: "description", content: appConfig.description }]
   },
  components: { vueDropzone: vue2Dropzone, Multiselect, Layout, PageHeader },
  data() {
    var title = 'Add DOMAIN PEMBELAJARAN'
    if (this.$route.meta.mode==='edit') {
      title = 'Edit DOMAIN PEMBELAJARAN'
    }
    return {
      title: title,
      items: [
        {
          text: 'DOMAIN_PEMBELAJARAN',
          href: '/',
        },
        {
          text: 'Add DOMAIN_PEMBELAJARAN',
          active: true,
        },
      ],
      payload: {
        "id": 0,
        "name": "",
        "description": "",
        "cluster_pendekatan": ""
      },
      options_cluster: [
        { value: "", text: 'Pilih cluster pendekatan' },
        { value: "1", text: 'Keterlibatan Siswa' },
        { value: "2", text: 'Praktek yang Responsif dan Inklusif' },
        { value: "3", text: 'Model Inovatif' },
        { value: "4", text: 'Kurikulum dan Akademik' },
        { value: "5", text: 'Kepemimpinan Instruksional' },
      ]
    }
  },
  mounted() {
    if ( this.$route.meta.mode==='edit' ){
      this.loadData(this.$route.params.id)
    }
  },
  methods:{
    loadData(idForm){
      this.stillLoading = true
      this.$store.dispatch(
          'domainpembelajaran/GET_DOMAIN_PEMBELAJARAN', idForm
      ).then((resp) => {
        if (resp.status === 200) {
          let data = resp.data.data
          let payload = this.payload
          payload.id = this.$route.params.id
          payload.name = data.name
          payload.description = data.description
          payload.cluster_pendekatan = data.cluster_pendekatan
        }
      }).catch(function () {

      })
    },
    saveData(){
      if (this.$route.meta.mode==='edit'){
        this.$store.dispatch('domainpembelajaran/PUT_DOMAIN_PEMBELAJARAN', this.payload)
            .then(() => {
              this.successmsg()
              this.$router.push('/domain_pembelajaran')
            }).catch(function () {
            this.warningmsg('Failed to save')
            })
      } else {
        this.$store.dispatch('domainpembelajaran/POST_DOMAIN_PEMBELAJARAN', this.payload)
            .then(() => {
              this.successmsg()
              this.$router.push('/domain_pembelajaran')
            }).catch(function () {
          // this.stillLoading=false
          // this.listMapel = []
          this.warningmsg('Failed to save')
        })
      }

    },
    successmsg() {
      Vue.swal({
        position: "top-end",
        icon: "success",
        title: "Your data has been saved",
        showConfirmButton: false,
        timer: 1500
      });
    },
    warningmsg(text) {
      Vue.swal({
        position: "top-end",
        icon: "warning",
        title: text,
        showConfirmButton: false,
        timer: 1500
      });
    },

  }
}
</script>

<style>
div.mce-edit-area > iframe {
  height: 400px !important;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
          <div class="card">
            <div class="col-lg-12 col-sm-12 col-md-12">
              <div class="card-body">
                <div class="form-group">
                  <label for="domain_pembelajaranname">Name</label>
                  <input id="domain_pembelajaranname" v-model="payload.name" name="domain_pembelajaranname" type="text" class="form-control" />
                </div>
                <div class="form-group">
                  <label for="cluster">Cluster</label>
                  <b-form-select v-model="payload.cluster_pendekatan" :options="options_cluster" name="cluster"></b-form-select>
                </div>
                <div class="form-group" style="height: 520px">
                  <label for="description">Description</label>
                  <tinymce toolbar1="" toolbar2="" plugins="[]" id="description" v-model="payload.description" name="description" ></tinymce>
                </div>
              </div>
            </div>
          </div>
          <button class="btn btn-primary mr-1" @click="saveData">Save Changes</button>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
